<template>
  <div id="pre-insc-cc3" class="d-flex align-center">
    <Countdown />
    <div v-if="$store.getters.getLoadingPage" class="loading d-flex justify-center align-center">
      <v-progress-circular
        indeterminate
        color="green"
      ></v-progress-circular>
      <br>
      <p>Carregando...</p>
    </div>
    <div class="bg"></div>
    <v-container fill-height>
      <v-row justify="center" align="start" class="my-4">
        <v-col cols="12" xl="5" md="6" class="mr-md-12">
          <div class="allcaps ml-2 mt-0 mb-12 mb-md-3 text-center text-md-left">
            <p><span class="underline px-1">Curso</span></p>
          </div>
          <div class="mt-8 text-center text-md-left">
            <h1 class="mb-6">Cannabis Aplicada a Reumatologia</h1>
            <!-- <p class="data-evento allcaps"><b>Data: </b><span v-if="briefing.duracao" class="px-2 mx-2">15 de Junho de 2024</span></p>
            <p class="allcaps">
              <b>Hora: </b>
              <span class="px-2 mx-2">08h às 13h</span>
            </p> -->
            <p class="data-evento allcaps">Conteúdo: <span v-if="briefing.duracao" class="px-2 mx-2">{{ briefing.duracao }} de aulas</span></p>
          </div>
          <div class="py-4">
            <p class="mt-6">Atenção, reumatologistas! Vem aí o <b>Curso Cannabis Aplicada a Reumatologia</b> que vai abranger desde a ReumatoPediatria até a Reumatologia!</p>
            <p>Neste curso abordamos diversos temas super importantes para a prescrição como:</p>
            <ul class="py-8 py-md-2">
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Indicações da Cannabis em Reumatologia</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Eficácia no tratamento da dor crônica</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Posologia e efeitos colaterais</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Quando iniciar o tratamento</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Segurança e contraindicações</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Formas de aplicação e perfil de segurança</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Evidências científicas</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Doenças reumáticas específicas</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Interações medicamentosas</span>
              </li>
              <li class="my-1">
                <v-icon color="green">mdi-square-small</v-icon>
                <span class="px-2 allcaps caption">Acesso à Cannabis</span>
              </li>
            </ul>
            <!-- <p>E para não perder o costume, convidamos um time ESPETACULAR de palestrantes, especialistas em suas áreas para compartilharem suas experiências.</p> -->
            <!-- <p>Aproveite nosso lote promocional e garanta já sua vaga com DESCONTO!</p> -->
            <div class="curso-info my-10">
              <p class="allcaps mb-3">
                <span class="font-weight-bold">Investimento:</span> 
                <!-- <span class="btn-primary px-1">R$300</span> -->
                <span v-if="briefing.price != '500'" class="price ml-3 mb-10 allcaps mt-4">
                  <strike class="red--text text--lighten-2 mr-2">R$500</strike>
                  <span class="btn-primary px-1">R${{ briefing.price }}</span>
                </span>
                <span v-else class="price ml-3 mb-10 allcaps mt-4">
                  <span class="btn-primary px-1">R$500</span>
                </span>
              </p>
              <p class="allcaps mt-8">Acesso ilimitado por 12 meses</p>
            </div>
          </div>
          <!-- ORGANIZAÇÃO -->
          <div class="mt-12 d-none d-md-inline">
            <p class="overline text-center text-md-left">Organização</p>
            <v-row class="">
              <v-col
                v-for="(org, i) in orgs"
                :key="i"
                cols="12"
                md="3"
                class="mr-md-8 my-10 my-md-0"
              >
                <a
                  :href="org.href"
                  target="_blank"
                >
                  <v-img
                    :src="org.src"
                    alt=""
                    contain
                    class="orgs-img"
                    position="center"
                    :href="org.href"
                  ></v-img>
                </a>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <v-col id="form" cols="12" xl="4" md="4" class="px-0">
          <v-card
            class="px-5 py-7 pb-0 rounded-r-xl green--border"
            outlined
            flat
          >
            <!-- <h3 class="text-center allcaps ml-2 mt-0 mb-3"><span class="white green--text px-1">Inscreva-se já!</span></h3> -->
            <!-- <p class="white--text mb-0 text-center">Preencha o formulário abaixo e faça a sua inscrição:</p> -->
            <div>
              <!-- <FormNews /> -->
              <!-- <FormMailchimp /> -->
              <InscForm cursoID="cc3"/>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row justify="center" class="py-12">
        <Quote />
      </v-row>
    </v-container>

    <!-- PROGRAMA -->
    <v-container>
      <v-row justify="center" class="mt-8 mb-4">
        <!-- <v-col cols="12" class="text-center">
          <h2>O que o curso irá abordar?</h2>
        </v-col> -->
        <v-col cols="12" md="11" xl="9" class="px-0">
          <h3 class="txt2 mb-8 text-center text-md-left"><span class="btn-primary px-1">Programa</span></h3>
          <v-expansion-panels class="programa">
            <v-expansion-panel
              v-for="(item,i) in programa"
              :key="i"
            >
              <v-expansion-panel-header class="txt-2 text-center">
                <p class=" mb-0 caption"><b>{{ item.title.pre }}</b> {{ item.title.txt ? '- '+item.title.txt : '' }}</p>
                <template v-slot:actions>
                  <v-icon class="cc-primary--text">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-4">
                <!-- <ul>
                  <li v-for="(palestra, i) in item.palestras" :key="i" class="palestra">
                    <v-icon color="green">mdi-square-small</v-icon>
                    {{ palestra.nome }}
                  </li>
                </ul> -->
                <div v-for="(palestra, i) in item.palestras" :key="i" class="palestra text-center">
                  <!-- <p class="hora">{{ palestra.hora }}</p> -->
                  <p class="nome body-1"><b>{{ palestra.nome }}</b></p>
                  <p class="nome body-2">{{ palestra.subtitulo }}</p>
                  <p class="palestrante">{{ palestra.palestrante }}</p>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <!-- PALESTRANTES -->
    <v-container>
      <v-row justify="center" class="my-4">
        <v-col cols="12" md="11" xl="9" class="px-0 text-center">
          <h3><span class="txt2 alt-text">Palestrantes</span></h3>
        </v-col>
        <v-col cols="12" md="12" xl="9" class="px-8">
          <div class="palestrantes d-flex flex-wrap flex-md-nowrap justify-center mt-8">
            <div
              v-for="(p, i) in palestrantes"
              :key="i"
              class="palestrante px-6 col-12 col-md-5"
            >
              <div class="d-flex align-center justify-center">
                <div class="mr-4">
                  <!-- <v-avatar
                    size="70"
                  > -->
                  <div class="">
                    <img
                      :src="p.src"
                      class="p-img avatar"
                      :alt="p.nome"
                      :title="p.nome"
                      width="70px"
                      height="70px"
                    >
                  </div>
                  <!-- </v-avatar> -->
                </div>
                <div>
                  <p class="p-nome mb-1"><span class="underline mb-0 pb-0">{{ p.nome }}</span></p>
                  <p class="allcaps mb-0">{{ p.esp }}</p>
                </div>
              </div>
              <!-- <v-img
                :src="p.src"
                class="p-img"
                :alt="p.nome"
                :title="p.nome"
                width="80px"
                height="80px"
              ></v-img> -->
              <p class="text-md-center">{{ p.info }}</p>
            </div>
          </div>
        </v-col>

      </v-row>
    </v-container>

    <v-container fluid id="como-funciona" class="pb-0">
      <v-row justify="center" class="">
        <v-col cols="12" class="cc-primary px-0 pt-12 pb-0 text-center">
          <h2 color="">Como funciona o curso</h2>
          <p color="">Veja quando e onde quiser!</p>
        </v-col>
        <v-container fluid class="py-0">
          <v-row class="d-flex vantagens cc-primary py-12 px-6 px-md-12">
            <v-col
              v-for="(v,i) in vantagens"
              :key="i"
              cols="12"
              md="3"
              xl="3"
              class="vantagem text-center px-6 py-4"
            >
              <div class="d-flex vant px-8 py-12">
                <v-icon color="green" class="mb-3" large>{{ v.icon }}</v-icon>
                <h4 class="mb-4">{{ v.title }}</h4>
                <p>{{ v.desc }}</p>
              </div>
            </v-col>
          </v-row>
          <v-row class="d-flex vantagens cc-primary py-12 px-md-12">
            <v-col cols="12" class="text-center">
              <h2 class="mb-12">
                <span class="py-1">
                  Tá esperando o que?
                </span>
              </h2>
              <div class="btn-primary--alt py-4 px-2 mx-auto" style="max-width: 500px">
                <a class="allcaps btn-primary--alt px-2 py-1" @click.stop="scrollTop()">
                  Faça já sua inscrição!
                </a>
              </div>
            </v-col>
            <!-- <v-col cols="12">
              <div>
                <FormBottom />
              </div>
            </v-col> -->
          </v-row>
        </v-container>
      </v-row>
    </v-container>
    <!-- <v-container>
      <v-row></v-row>
    </v-container> -->
    <Footer />
    
    <!-- ------- SNACKBAR FEEDBACK -------- -->
    <v-snackbar 
      v-model="$store.state.feedback.show"
      v-if="$store.state.feedback" 
      :color="$store.state.feedback.color" 
      :class="$store.state.feedback.textColor" 
    >
      {{$store.state.feedback.message}}
      <v-btn
        otlined
        class="ml-2"
        fab
        icon
        @click.stop="$store.commit('setFeedback', null)" 
      >
        {{$store.state.feedback.btnTxt}}
        <!-- <v-icon>mdi-close</v-icon> -->
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// import FormNews from '@/components/forms/FormNews'
// import FormBottom from '@/components/forms/FormNews'
import Quote from '@/components/layout/Quote'
import Footer from '@/components/layout/NewFooter'
// import FormMailchimp from '@/components/forms/FormMailchimp'
import InscForm from '@/components/forms/InscForm'
import Countdown from '@/components/Countdown'

export default {
  name: 'Pre-Inscricao',
  components: {
    // FormMailchimp,
    // FormNews,
    // FormBottom,
    Quote,
    Footer,
    InscForm,
    Countdown
  },
  data() {
    return {
      briefing: {
        title: 'Cannabis Aplicada a Reumatologia',
        desc: '',
        duracao: '5h',
        price: '500',
        fullPrice: '500'
      },
      orgs: [
        {
          src: require('../assets/logoCMF.png'),
          href: 'https://centrofluminense.com.br/'
        },
        {
          src: require('../assets/logo-352-full.png'),
          href: 'https://agencia352.com/'
        },
        {
          src: require('../assets/logo-we4u.png'),
          href: 'https://we4u.com.br/'
        },
      ],
      programa: [
        {
          title: {
            pre: 'Bloco 1',
            // txt: 'História da Cannabis Medicinal e Legislação Vigente',
          },
          palestras: [
            {
              nome: 'Introdução a Cannabis',
              subtitulo: 'Caracterização da planta e dos seus componentes. Aplicações das diversas partes da planta. Economia da Cannabis no mundo',
              palestrante: 'Dra Viviane Rosa  |  08h00 - 08h15'
            },
            {
              nome: 'História da Cannabis e seu uso medicinal',
              subtitulo: 'Dados históricos, desde a Pré-história a William O Shaunessy',
              palestrante: 'Dra Viviane Rosa  |  08h15 - 08h30'
            },
            {
              nome: 'História do Sistema Endocanabinoide',
              subtitulo: 'Passos históricos recentes. Importância de Raphael Mechoulan',
              palestrante: 'Dra Viviane Rosa  |  08h30 - 08h45'
            },
            {
              nome: 'Anatomia do Sistema Endocanabinoide',
              subtitulo: 'Receptores, Ligantes e endocanabinoides',
              palestrante: 'Dra Viviane Rosa  |  08:45 - 09h15'
            },
          ]
        },
        {
          title: {
            pre: 'Bloco 2',
            // txt: 'Canabidiol e Seus derivados: Da composição ao mecanismo de funcionamento',
          },
          palestras: [
            {
              nome: 'Do plantio à extração',
              subtitulo: 'Principais aspectos, características da extração por CO2 supercrítico, Importância do Certificado de Análise e como interpretar os dados',
              palestrante: 'Dra Viviane Rosa  |  09h15 - 09h30'
            },
            {
              nome: 'CBD e THC',
              subtitulo: 'Principais receptores e ações no organismo',
              palestrante: 'Dra Selma Merenlender  |  09h30 - 09h50'
            },
            {
              nome: 'Demais Canabinóides, Terpenos e Flavonoides',
              subtitulo: '',
              palestrante: 'Dra Selma Merenlender  |  09h50 - 10h05'
            },
          ]
        },
        {
          title: {
            pre: 'Bloco 3',
            // txt: 'Como usar o Canabidiol e seus derivados no tratamento de doenças reumáticas',
          },
          palestras: [
            {
              nome: 'Overview das principais indicações medicinais de Cannabis',
              subtitulo: '',
              palestrante: 'Dra Selma Merenlender  |  10h05 - 10h20'
            },
            {
              nome: 'Indicações em Reumatologia I',
              subtitulo: 'Síndromes dolorosas',
              palestrante: 'Dra Selma Merenlender  |  10h20 - 10h40'
            },
            {
              nome: 'Indicações em Reumatologia II',
              subtitulo: 'Doenças Imunomediadas',
              palestrante: 'Dra Selma Merenlender  |  10h40 - 11h00'
            },
            {
              nome: 'Indicações na Reumatopediatria e Autismo',
              subtitulo: '',
              palestrante: 'Dra Viviane Rosa  |  11h00 - 11h20'
            },
          ]
        },
        {
          title: {
            pre: 'Bloco 4',
            // txt: 'Como usar o Canabidiol e seus derivados no tratamento de doenças reumáticas',
          },
          palestras: [
            {
              nome: 'Como prescrever Cannabis medicinal Parte I',
              subtitulo: 'Tipos de óleo, como entender as apresentações, diferenças de Apresentações importadas e nacionais. Tipos de receita',
              palestrante: 'Dra Selma Merenlender  |  11h20 - 12h00'
            },
            {
              nome: 'Como prescrever Cannabis medicinal Parte II',
              subtitulo: ' Interações medicamentosas, desmame de BZD e anticonvulsivantes. Interações com opiáceos',
              palestrante: 'Dra Selma Merenlender  |  12h00 - 12h20'
            },
            {
              nome: 'Futuro da Cannabis Medicinal',
              subtitulo: '',
              palestrante: 'Dra Selma Merenlender  |  12h20 - 12h30'
            },
            {
              nome: 'Apresentação de caso clínico',
              subtitulo: 'reumatológico adulto',
              palestrante: 'Dra Selma Merenlender  |  12h30 - 12h45'
            },
            {
              nome: 'Apresentação de caso clínico',
              subtitulo: 'reumatológico pediátrico',
              palestrante: 'Dra Viviane Rosa  |  12h45 - 13h00'
            },
            {
              nome: 'Perguntas e respostas',
              subtitulo: '',
              palestrante: 'Platéia e Preceptoras'
            },
            {
              nome: 'Encerramento',
              subtitulo: '',
              palestrante: 'Dra Selma Merenlender e Dra Viviane Rosa'
            },
          ]
        },
      ],
      palestrantes: [
        // {
        //   id: 'alessandra',
        //   nome: 'Dra. Alessandra Soares',
        //   esp: 'Ex-Diretora da ANVISA',
        //   info: 'Farmacêutica por formação e com mais de 21 anos de experiência no mercado, a Dra Alessandra Soares é Ex Diretora de Gerência de Medicamentos Específicos da ANVISA participou ativamente dos estudos para a elaboração e implementação da norma que regulamenta a autorização do órgão para produtos a base de cannabis em todo o território Brasileiro.',
        //   src: require('../assets/alessandra.png'),
        // },
        // {
        //   id: 'soraia',
        //   nome: 'Soraia Costa Silva',
        //   esp: 'Perfumista e Mestre em Química Quântica',
        //   info: 'Além de Mestre em Química Quântica, Soraia da Costa Silve é Perfumista Sênior da IFF. Conceituada no Brasil e no Mundo, a Perfumista é responsável por desenvolver fragrâncias de empresas como Tommy Hilfiger; Ariel, e muitos outros. Soraia da Costa Silva é nossa convidada para falar sobre os terpenos e flavonóides e seus efeitos no corpo.',
        //   src: require('../assets/soraia.png'),
        // },
        {
          id: 'selma',
          nome: 'Dra. Selma Merenlender',
          esp: 'Reumatologista',
          info: 'Ex-Presidente da Sociedade de Reumatologia do Rio de Janeiro; Diretora Técnica do Centro Multidisciplinar Fluminense. Além de um dos grandes nomes da Reumatologia do Brasil, a Dra Selma Merenlender possui vasta experiência no uso de Cannabis Medicinal no Tratamento de Doenças Reumatológicas.',
          src: require('../assets/selma.png'),
        },
        {
          id: 'viviane',
          nome: 'Dra. Viviane Rosa',
          esp: 'Reumatologista Pediátrica',
          info: 'Dra Viviane Rosa é Reumatologista Pediatrica da Rede dor, com vasta experiência no uso de Cannabis Medicinal no tratamento de doenças de sua área.',
          src: require('../assets/viviane.jpg'),
        },
        // {
        //   id: 'octavio',
        //   nome: 'Dr. Octávio Pavan',
        //   esp: 'Psiquiatra',
        //   info: 'O Dr. Octávio Pavan é médico psiquiatra por formação e possui vasta experiência com o  Uso de Canabis Medicinal no tratamento de doenças psiquiátricas como Depressão e Ansiedade.',
        //   src: require('../assets/octavio.png'),
        // },
        // {
        //   id: 'filipe',
        //   nome: 'Dr. Filipe Gusman',
        //   esp: 'Geriatra e Cuidados paliativos',
        //   info: 'O Dr Felipe Gusman é geriatra pela SBGG, Fundador e atual presidente da Academia Nacional de Cuidados Paliativos – Seccional Rio de Janeiro. Membro da Câmara técnica de Medicina Paliativa do CREMERJ. Possui grande experiência com o uso de Cannabis medicinal.',
        //   src: require('../assets/filipe.png'),
        // },
        // {
        //   id: 'natalia',
        //   nome: 'Dra. Natalia Mourão',
        //   esp: 'Ortopedista e Médica do Esporte',
        //   info: 'A Dra Natalia Mourão é Ortopedista e Traumatologista titulada pela SBOT, Médica do Esporte titulada pela SBMEE, Médica da Confederação Brasileira de Taekwondo, Vice presidente da Associação de Mulheres Ortopedistas do Brasil (AMOB).',
        //   src: require('../assets/natalia.png'),
        // },
        // {
        //   id: 'diogo',
        //   nome: 'Diogo Souza',
        //   esp: 'Preparador Físico de Alto Rendimento',
        //   info: 'Diogo Souza é formado em Educação Física e Pós Graduado em Exercícios Físico a Reabilitação Cardíaca e a Grupos Especiais. Com uma enorme  experiência em preparação física em alto rendimento onde até hoje  atua no condicionamento físico de atletas como Rogério Minotouro (UFC) ; José Mario Sperry(PRIDE); Toquinho (Ex-UFC), o  preparador físico divide seu tempo entre sua escola de excelência de preparação Física, Ludus Actius,  e no condicionamento físico de atletas de luta de alto rendimento. ',
        //   src: require('../assets/diogo.png'),
        // },
        // {
        //   id: 'kawazoe',
        //   nome: 'Dr. José Kawazoe',
        //   esp: 'Médico do Exercício e do Esporte',
        //   info: 'Especialista em Cardiologia e em Medicina do Exercício e do Esporte. Professor Adjunto do Instituto Biomédico da Universidade Federal Fluminense. Ex-Presidente da Sociedade Brasileira de Medicina do Exercício e do Esporte - SBMEE (2009/2011). Presidente da Confederação Panamericana de Medicina do Esporte - COPAMEDE. Tesoureiro da Federação Internacional de Medicina do Esporte - FIMS. Presidente da Comissão de Autorização para Uso Terapêutico (CAUT) da Autoridade Brasileira de Controle de Dopagem (ABCD)',
        //   src: require('../assets/kawazoe.png'),
        // },
        // {
        //   id: 'jimmy',
        //   nome: 'Dr. Jimmy Fardin',
        //   esp: 'Ortopedista e Traumatologista',
        //   info: 'Dr Jimmy Fardin ortopedista e traumatologista, cirurgião de joelho e especialista em cannabis medicinal desde 2018',
        //   src: require('../assets/jimmy.png'),
        // },
      ],
      vantagens: [
        {
          icon: 'fas fa-globe',
          title: '100% Online',
          desc: 'Nosso curso é 100% Online, com toda a comodidade e conforto desse formato.'
        },
        {
          icon: 'fas fa-unlock',
          title: '12 meses de acesso liberado',
          desc: 'Está ocupado no dia? Não tem problema, você tem até 1 ano para acessar.'
        },
        {
          icon: 'fas fa-play',
          title: 'Veja e reveja',
          desc: 'Durante um ano você terá acesso liberado para você ver e rever quantas vezes quiser.'
        },
        {
          icon: 'fas fa-question',
          title: 'Pintou dúvida?',
          desc: 'Além de poder tirar suas dúvidas via email, você fará parte de um grupo de debates com os palestrantes.'
        },
      ],
    }
  },
  mounted() {
    this.$vuetify.theme.dark = false
  },
  methods: {
    scrollTop() {
      console.log(this.$vuetify.breakpoint.name === 'xs')
      if(this.$vuetify.breakpoint.name === 'xs') {
        document.getElementById("form").scrollIntoView();
      } else {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

#pre-insc-cc3 {
  padding-top: 30px;
  min-height: 100vh;
  flex-direction: column;

  @include xs {
    // text-align: center;
  }
  .bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // background-image: url('../assets/bg2.jpg');
    background-image: url('../assets/bg.png');
    background-size: 100%;
    background-position: center;
    z-index: 0;
    // width: 100vw;
    // height: 100vh;
    @include xs {
      background-position: center;
      background-size: cover;
    }
  }
  .container div {
    z-index: 1;
  }
  h1 {
    font-size: 2.2rem;
    line-height: 2.5rem;
    font-weight: 900;
    // font-style: italic;
    @include xl {
      font-size: 3rem;
    line-height: 3.2rem;
    }
  }
  .data-evento {
    span {
      background-color: $primary;
      color: #ffffff;
    }
  }
  .curso-info {
    p {
      font-size: .8em;
      margin-bottom: 5px;
      span {}
    }
    .price {
      font-size: 1.2em;
    }
  }
  ul {
    list-style: none;
    padding-left: 0;
    // li {
    //   background: $primary;
    //   color: #ffffff;
    // }
  }
  .v-expansion-panel-header {
    border-bottom: solid 1px $primary;
  }
  .v-expansion-panel-content {
    background-color: #fbfbfb;
  }
  .palestrantes {
    .avatar {
      border: solid 2px $primary;
      border-radius: 50%;
      transition: all .3s;
    }
    .palestrante {
      margin-bottom: 30px;
      p.p-nome {
        font-weight: bold;
        font-size: 1.1em;
      }
      p.allcaps {
        font-size: .7em;
        font-weight: normal;
      }
      p{
        font-size: .8em;
      }
    }
  }
  #como-funciona {
    border-radius: 20px;
    h2 {
      font-size: 2em;
    }
    // .row:first-child {
    //   border-radius: 20px
    // }
    .vantagens {
      align-content: stretch;
      justify-content: space-around;

      h2 {
        font-size: 3em;
      }
      .vantagem {
        // padding-bottom: 100px;
        .vant {
          flex-direction: column;
          align-items: center;
          height: 100%;
          background-color: #ffffff;
          color: #191919;
          border-radius: 20px;
          h4 {
            font-size: 1.1em;
          }
          p {
            font-size: .9em;
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .orgs-img {
    height: 30px;
    @include xs {
      height: 50px;
    }
  }
  .green--border {
    border-color: #6BBD78 !important;
    border: solid 2px;
  }
  .loading {
    position: fixed;
    bottom: 0;
    top: 0;
    right: 0;
    left: 0;
    background-color: rgba($color: #FFFFFF, $alpha: .8);
    z-index: 9;
    // display: flex;
    flex-direction: column;
    // justify-items: center;
    // align-content: center;
  }
}
</style>